<template>
  <div class="video-preview" :id="id" :style="ownStyle">
    <!-- Mode 0 H5 Native -->
    <H5Videojs v-if="videoMode == 999" ref="h5VideoJS" :src="videoSrc" :option="videojsOption"></H5Videojs>
    <!-- Mode 2 VLC -->
    <VLC v-if="videoMode == 2" :options="vlcOptions" ref="vlc" :src="videoSrc"></VLC>
    <!-- Mode 3 HK -->
    <HKVideo v-else-if="videoMode == 3" :proxyHost="proxyHost" ref="hkVideo" :code="hkVideoCode" :config="hkConfig" @closeCallback="closeCallback"></HKVideo>
    <!-- Mode 13 HKWS -->
    <HKWebSocket v-else-if="videoMode == 13" :src="videoSrc"></HKWebSocket>
    <!-- Mode 8 DH -->
    <Dahua v-else-if="videoMode == 8" :code="dhVideoCode" :config="dhConfig"></Dahua>
    <!-- Mode 7 MJ -->
    <MJVideo ref="mjVideo" v-else-if="videoMode == 7" :config="mjConfigStr"></MJVideo>
    <!-- Mode 11 Jessibuca -->
    <Jessibuca ref="jeVideo" v-else-if="(videoMode == 0 || videoMode == 11) && jessibucaLoaded" :src="videoSrc" :options="jessibucaOptions" 
    @playFailedAndPaused="playFailedAndPaused"
    @recordBlob="recordBlob"
    v-on="$listeners"
    ></Jessibuca>
    <!-- <Jessibuca ref="jeVideo" v-else-if="videoMode == 11 && jessibucaLoaded" :src="videoSrc" :options="jessibucaOptions" @playFailedAndPaused="playFailedAndPaused"></Jessibuca> -->
    <!-- Mode 14 万华 -->
    <WHVideo ref="whVideo" v-else-if="videoMode == 14" :src="videoSrc" :options="whOptions"></WHVideo>
    <!-- Mode 1 Iframe -->
    <Iframe ref="iframe" v-else-if="videoMode == 1" :src="videoSrc"></Iframe>
    <!-- Mode 15 Uniview -->
    <Uniview ref="uniview" v-else-if="videoMode == 15" :proxyHost="proxyHost" :code="ysCode" :config="univiewConfig"></Uniview>
    <DHicc ref="DHicc"
      v-else-if="videoMode == 16"
      @createSuccess="createSuccess"
      @createError="createError"
      @talkError="talkError"
      @clickWindow="clickWindow"
      @changeDivision="changeDivision"
      @picCap="picCap"
      @notifyTalk="notifyTalk"
      @realSuccess="realSuccess"
      @realError="realError"
      @destroySuccess="destroySuccess"
      :option="dhIccOptions"
      :src="videoSrc"
      :proxyHost="proxyHost"
    >
    </DHicc>
    <slot name="video-slot"> </slot>
    <!-- 错误提示 -->
    <div v-show="showError && vpErrorShow" class="video-preview-error">
      <div>
        <p class="info">{{ vpError.msg }}</p>
        <a class="btn" @click="retryPlay">尝试起播</a>
      </div>
    </div>
  </div>
</template>

<script>
// ****************提供纯粹的播放功能******************
// mode 0 H5 1 iframe 2 vlc 3 hk 4 不明被占用 5 不明被占用 6 不明 7 明景 8 大华OCX 9 不明 10 不明 11 Jessibuca 12 海康iVMS特殊平台 13 海康websocket播放 14 万华webgl播放 15 宇视平台
// import axios from 'axios'
import axios from './axios'
import Dahua from './Dahua.vue'
import MJVideo from './MJVideo.vue'
import HKVideo from './HKVideo.vue'
import VLC from './vlc.vue'
import Jessibuca from './Jessibuca.vue'
import H5Videojs from './H5Videojs.vue'
import Iframe from './Iframe.vue'
import HKWebSocket from './HKWebSocket.vue'
import WHVideo from './WHVideo.vue'
import Uniview from './Uniview.vue'
import DHicc from './DHicc.vue'
import { initIframeSafety, detectThirdPartyIframes } from './utils/iframeSafety'
import { setupBaiduIframeComm } from './utils/cspcommunicator'

import './../style/common.css'
import {
  supportSpecialFlagUrl,
  supportRepackingUrl,
  supportHikvisonRepackingUrl,
  supportNYUrl,
  supportIVMSUrl,
  supportAYUrl,
  supportNewPreviewUrl
} from './getVideoUrl'
import {
  IOT_SPECIAL_FLAG,
  SOURCE_ENUM,
  SPECIAL_FLAG,
  URLS,
  USE_NEW_PREVIEW_VIDEO_SOURCE,
  VIDEO_MODE_ENUM,
  VIDEO_PROTOCOL,
  VP_ERROR,
  VP_ERROR_CONFIG
} from '../config'
import { VDate } from '../utils/date'
import { EventBus, Events } from '../utils/eventbus'
import { Action } from './toolbar/action'
import moment from 'moment'

export default {
  name: 'video-preview',
  components: { HKVideo, VLC, Dahua, Iframe, MJVideo, Jessibuca, HKWebSocket, WHVideo, Uniview, DHicc, H5Videojs},
  props: {
    code: String, // 公司内部网络使用
    ownStyle: {
      type: String,
      default: ''
    },
    mode: {
      type: [Number, String], //视频类型 0 Native 1 IFrame 2 VLC 3 HK
      required: false,
      default: 0
    },
    src: [Number, String], // 视频地址
    hkCode: String, // 海康Code
    hkConfig: {
      type: Object,
      default: () => {
        return {
          playMode: 0,
          showToolBar: 1,
        }
      }
    }, //海康配置 appKey secret ip port
    dhCode: String, // 大华Code
    dhConfig: {
      type: Object,
      default: () => {
        return null
      }
    }, // 大华配置
    mjCOde: String, // 明景Code
    mjConfig: {
      type: Object,
      default: () => {
        return null
      }
    }, // 明景配置
    videojsOption: Object,
    vlcOptions: Object,
    proxyHost: {
      type: String,
      default: ''
    },
    jessibucaOptions: Object, // jessibuca配置
    whOptions: Object, // wh播放配置
    dhIccOptions: {type:Object,default:()=>{
      return {
        windowType:0
      }
    }}, // DHicc配置
    DHvideoType:{
      type:String,
      default:'video1'  // video1: 预览   video2：回看
    },
    // DHstartTime:{
    //   type:String,
    //   default: Math.floor(
    //       new Date(moment().startOf('days')).getTime() / 1000
    //   ) 
    // },
    // DHstartTime:{
    //   type:String,
    //   default: Math.floor(
    //       new Date(moment().endOf('days')).getTime() / 1000
    //   )
    // },
    muted: Boolean,
    univiewConfig: Object, // 宇视配置
    univiewCode: String, // 宇视Code
    autoStart: {
      type: Boolean,
      default: true
    }, // 自动加载控制字段
    showError: Boolean,
    crossContainer: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      previewMode: '',
      iframeSrc: '',
      timer: null,
      videoSrc: null,
      hkVideoCode: null,
      activeComponent: null,
      ysCode: null,
      videoMode: null,
      ptzUIFlag: false,
      jessibucaLoaded: false,
      vpErrorShow: true,
      dhVideoCode: null,
      vpError: {
        code: '',
        msg: ''
      },
      mjConfigStr: '',
      hlsErrorMaxCount: VP_ERROR_CONFIG.errorMaxCount, //可以接受的hls发生404错误的次数
      // DHvideoType:'video1', // video1: 预览   video2：回看
      moment,
      DHstartTime: Math.floor(
          new Date(moment().startOf('days')).getTime() / 1000
      ),
      DHendTime: Math.floor(
          new Date(moment().endOf('days')).getTime() / 1000
      ),
      initState:false,
      iframeObserver: null, // 添加iframe观察器
      hasBaiduIframe: false, // 是否存在百度iframe
    }
  },
  computed: {
    id: function (n, o) {
      return `video-preview${this.mode}`
    }
  },
  mounted() {
    // this.start()
    EventBus.$on(Events.HLS_NETWORK_ERROR, this.onHLSNetworkError)
    // 初始检测页面中是否存在百度iframe
    this.detectAndHandleBaiduIframe();
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    EventBus.$off(Events.HLS_NETWORK_ERROR, this.onHLSNetworkError)
    // 清理iframe观察器
    if (this.iframeObserver) {
      this.iframeObserver.disconnect();
      this.iframeObserver = null;
    }
  },
  watch: {
    videoMode: {
      handler(nVal) {
        if (nVal === 11 || nVal === 0) {
          console.log('deployBaseRoute',window.deployBaseRoute);
          fetch(`${window.deployBaseRoute || '/'}public/vendors/iot/jessibuca-pro.js`, {
          // fetch(`${window.deployBaseRoute || '/'}static/js/jessibuca/jessibuca-pro.js`, { //wvp引用static路径
          // fetch(`public/vendors/iot/jessibuca-pro.js`, {
            headers:{
              'Accept': '*/*'
            }
          }).then(res=>{
            return res.text();
          }).then(result => {
            new Function(result)();
            this.jessibucaLoaded = true;
          }).catch(err => {
            console.error(err);
            // require('../thirdparty/jessibuca/jessibuca-pro')
            // this.jessibucaLoaded = Boolean(window.JessibucaPro);
          })
        }
      },
      immediate: true
    },
    code: {
      handler(nVal) {
        console.error('code',nVal);
        nVal && this.start()
      },
      deep: true,
      immediate:true,
    },
    dhCode: {
      handler(nVal) {
        if (!nVal) {
          return
        }
        this.dhVideoCode = this.dhCode
      },
      immediate: true
    },
    univiewCode: {
      handler(nVal) {
        if (!nVal) {
          return
        }
        this.ysCode = this.univiewCode
      },
      immediate: true
    },
    hkCode: {
      handler(nVal) {
        if (!nVal) {
          return
        }
        this.start();
        // this.hkVideoCode = this.hkCode;
      },
      immediate: true
    },
    hkVideoCode: {
      handler(nVal) {
        // console.log('hkVideoCode22233',nVal);
        if (!nVal) {
          return
        }
      },
      immediate: true
    },
    // 此处以Code变化为准
    mode(newVal, oldVal) {
      if (this.code) {
        this.videoMode = null
      } else {
        this.videoMode = newVal
      }
    },
    // 监听改变初始化SRC
    src: {
      handler(newVal, oldVal) {
        console.log('src update!', newVal)
        this.initState = false;
        this.start()
      },
      immediate: true
    },
    muted: {
      handler(nVal) {
        this.changeMute(nVal)
      },
      immediate: true
    },
    DHvideoType: {
      handler(val) {
      if(this.dhIccOptions){
        this.dhIccOptions.windowType = val === 'video1' ? 0 : 7
      }
      },
      immediate: true,
      deep:true
    },
  },
  methods: {
    async start() {
      const { code } = this
      // 如果当前组件包含code 走公司内部播放流程
      // ICVS 暂时使用新的获取流地址接口
      // console.log('ccccc',code,this.hkCode,this.hkConfig);
      console.log('start code:',code,this);
      if (code) {
        // 跨容器查询
        if (this.crossContainer) {
          let params = {
            params: {
              code
            }
          }
          let res = await axios.get(this.proxyHost + URLS.getVideoByCodeUrl, params).catch((e) => {
            this._showErrorMsg(VP_ERROR.GET_STREAM_FAIL)
            return 'error'
          })
          if (res && res.status === 200 && res.data.result) {
            // console.log(218,params,res.data);
            this.iotVideoObj = res.data.result
            this.hkVideoCode = res.data.result.code
            this.dhVideoCode = res.data.result.code
            this.univiewCode = res.data.result.code
            this.hkConfig.transType = (this.iotVideoObj.transType === undefined || this.iotVideoObj.transType === null) ? 1 : this.iotVideoObj.transType;
            this.startInit()
          } else {
            this._showErrorMsg(VP_ERROR.CODE_NOTFOUND)
          }
          return
        }
        // 普通查询
        let params = {
          params: {
            categoryName: '',
            categoryId: '',
            search: '',
            code,
            codeSign: 'equal',
            pageSize: 150,
            pageNum: 1
          }
        }
        let res = await axios.get(this.proxyHost + URLS.getVideoUrl, params).catch((e) => {
          this._showErrorMsg(VP_ERROR.GET_STREAM_FAIL)
          return 'error'
        })
        console.warn(1111,res.data.result.list)
        if (res && res.status === 200 && res.data.result.list.length > 0) {
          this.iotVideoObj = res.data.result.list[0]
          this.hkVideoCode = res.data.result.list[0].code
          this.dhVideoCode = res.data.result.list[0].code
          this.univiewCode = res.data.result.list[0].code
          this.hkConfig.transType = (this.iotVideoObj.transType === undefined || this.iotVideoObj.transType === null) ? 1 : this.iotVideoObj.transType;
          this.$emit('dhCrossOrigin',this.iotVideoObj)
          this.startInit()
        } else {
          this._showErrorMsg(VP_ERROR.CODE_NOTFOUND)
        }
      } else {
        this.videoMode = this.mode
        // 非code模式 区分海康code字段与大华Code字段
        if (this.hkCode) {
          this.hkVideoCode = this.hkCode
        }
        if (this.dhCode) {
          this.dhVideoCode = this.dhCode
        }
        // 0 Native 1 IFrame 2 VLC 3 HK
        this.setVideoVal(this.src, this.videoMode, this.hkVideoCode, this.dhVideoCode, this.univiewCode)
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.init()
        }, 1000)
      }
    },
    // 初始化分装
    async startInit() {
      let mode = this.iotVideoObj.mode
      let url = this.iotVideoObj.stream
      const source = this.iotVideoObj.source
      const transType = this.hkConfig.transType
      // 优先级最高 兼容特殊URL对接安元平台
      if (url && url.indexOf(IOT_SPECIAL_FLAG) > -1) {
        let specialRes = await supportSpecialFlagUrl(this.proxyHost, this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        mode = specialRes.mode ? specialRes.mode : mode
        url = specialRes.url ? specialRes.url : url
      }
      // 提供自定义流转码播放
      if (!source && this.iotVideoObj.isProxyStream) {
        let repackRes = await supportRepackingUrl(this.proxyHost, this.iotVideoObj.stream, this.iotVideoObj).catch((e) => {
          this._showErrorMsg(VP_ERROR.AY_ZLK_REPACKAGE_FAIL)
          return e
        })
        mode = repackRes.mode ? repackRes.mode : mode
        url = repackRes.url ? repackRes.url : url
      }
      // 提供海康转流播放配置 支持外部配置传入 以及视频流配置
      // if (source && source === SOURCE_ENUM.hikvision && ((this.hkConfig && this.hkConfig.protocol) || this.iotVideoObj.isProxyStream)) { //废弃
      // if (source && source === SOURCE_ENUM.hikvision && (this.hkConfig && this.hkConfig.protocol)) {
      //   let hikRes = await supportHikvisonRepackingUrl(this.proxyHost, this.iotVideoObj, this.hkConfig).catch((e) => {
      //     this._showErrorMsg(VP_ERROR.HK_REPACKAGE_FAIL)
      //     console.error(e)
      //     return e
      //   })
      //   // console.log(296,hikRes);
      //   mode = hikRes.mode ? hikRes.mode : mode
      //   url = hikRes.url ? hikRes.url : url
      // }
      // 南耀特殊播放
      if (mode == 'NY') {
        let nyRes = await supportNYUrl(this.proxyHost, this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        mode = nyRes.mode ? nyRes.mode : mode
        url = nyRes.url ? nyRes.url : url
        this.playNYToken = nyRes.token
        this._startNyKeepAlive(nyRes.token)
      }
      // iVMS海康平台播放
      if (mode == VIDEO_MODE_ENUM.iVMSHK) {
        let ivmsRes = await supportIVMSUrl(this.proxyHost, this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        mode = ivmsRes.mode ? nyRes.mode : mode
        url = ivmsRes.url ? nyRes.url : url
      }
      // 安元平台播放取流
      if (this.iotVideoObj.source == SOURCE_ENUM.ay) {
        let ayRes = await supportAYUrl(this.proxyHost, this.iotVideoObj).catch((e) => {
          // console.error(e)
          this._showErrorMsg(VP_ERROR.AY_GET_STREAM_FAIL)
          return e
        })
        mode = ayRes.mode ? ayRes.mode : mode
        url = ayRes.url ? ayRes.url : url
      }

      //- 海康转流 --平台统一接入
      if(source && ['hikvision'].includes(source) && (mode==='0' && this.iotVideoObj.isProxyStream)){
          const proxyType =  'https:'==location.protocol ? 'wss': 'ws';
          let hkHls = await supportNewPreviewUrl(this.proxyHost, this.iotVideoObj, 'RTSP',proxyType, transType).catch((e) => {
          this._showErrorMsg(VP_ERROR.HK_HLS_FAIL)
          return e
        })
        mode = hkHls.mode ? hkHls.mode : mode
        url = hkHls.url ? hkHls.url : url
        return this.setVideoVal(url, mode, this.hkVideoCode, this.dhVideoCode, this.univiewCode);
      }
      //- 海康大华取h5流
      if(source && ['hikvision','dahuaicc','dahua8900'].includes(source) && (mode==='0' && !this.iotVideoObj.isProxyStream)){
          const proxyType =  'https:'==location.protocol ? 'wss': 'ws';
          let hkHls = await supportNewPreviewUrl(this.proxyHost, this.iotVideoObj, 'hls',proxyType, transType).catch((e) => {
          this._showErrorMsg(VP_ERROR.HK_HLS_FAIL)
          return e
        })
        mode = hkHls.mode ? hkHls.mode : mode
        url = hkHls.url ? hkHls.url : url
        return this.setVideoVal(url, mode, this.hkVideoCode, this.dhVideoCode, this.univiewCode);
      }
        //- 大华转流 --平台统一接入
       if(source && ['dahuaicc','dahua8900'].includes(source) && (mode==='0' || this.iotVideoObj.isProxyStream)){
           const proxyType =  'https:'==location.protocol ? 'wss': 'ws';
           let hkHls = await supportNewPreviewUrl(this.proxyHost, this.iotVideoObj, 'hls',proxyType).catch((e) => {
           this._showErrorMsg(VP_ERROR.HK_HLS_FAIL)
           return e
         })
         mode = hkHls.mode ? hkHls.mode : mode
         url = hkHls.url ? hkHls.url : url
         return this.setVideoVal(url, mode, this.hkVideoCode, this.dhVideoCode, this.univiewCode);
       }
       
      // 支持新的取流接口平台 暂时使用新的获取流地址接口
      if (this.iotVideoObj.source && USE_NEW_PREVIEW_VIDEO_SOURCE.indexOf(this.iotVideoObj.source) > -1) {
        let previewRes = await supportNewPreviewUrl(this.proxyHost,this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        mode = previewRes.mode ? previewRes.mode : mode
        url = previewRes.url ? previewRes.url : url
      }

      this.setVideoVal(url, mode, this.hkVideoCode, this.dhVideoCode, this.code)
      // 防止重复触发
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.init()
      }, 1000)
    },

    // 除海康需视同code外其余的均为url
    setVideoVal(src, mode, hkCode, dhCode, univiewCode) {
      this.hkVideoCode = '';
      if (typeof mode === 'string') {
        this.videoMode = Number(mode)
      }
      this.$nextTick(() => {
        if (this.videoMode == 0) {
          this.videoSrc = src
        } else if (this.videoMode == 1) {
          this.videoSrc = src
        } else if (this.videoMode == 2) {
          this.videoSrc = src
        } else if (this.videoMode == 3) {
          this.hkVideoCode = hkCode
        } else if (this.videoMode == 8) {
          this.dhVideoCode = dhCode
        } else if (this.videoMode == 7) {
          this.mjConfigStr = src
        } else if (this.videoMode == 11) {
          this.videoSrc = src
        } else if (this.videoMode == 13) {
          this.videoSrc = src
        } else if (this.videoMode == 14) {
          this.videoSrc = src
        } else if (this.videoMode == 15) { 
          this.ysCode = univiewCode
        } else if (this.videoMode == 16) {
          this.videoSrc = src
        } else if (this.videoMode == 999) {
          this.videoSrc = src
        }
      })
    },
    // 南耀模式保活
    _startNyKeepAlive(token) {
      this.nyLoopInterval = setInterval(() => {
        axios.get(this.proxyHost + URLS.NYKeepAlive, { params: { token } }).then((res) => {})
      }, 15000)
    },
    // 南耀模式停止
    _stopNyPlay() {
      if (this.nyLoopInterval) {
        clearInterval(this.nyLoopInterval)
        this.nyLoopInterval = null
      }

      return new Promise((resolve, reject) => {
        axios
          .get(this.proxyHost + URLS.NYClose, { params: { token: this.playNYToken } })
          .then((res) => {
            this.playNYToken = null
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    _hideErrorMsg() {
      this.vpErrorShow = false
    },
    _showErrorMsg(msg) {
      this.vpError.msg = msg
      this.vpErrorShow = true
    },
    retryPlay() {
      this.vpErrorShow = false
      this.start()
    },
    // 盘锦myeyes 索引404特殊处理
    onHLSNetworkError(data) {
      if (this.iotVideoObj && this.iotVideoObj.source === SOURCE_ENUM.myeyes && data.response && data.response.code == 404) {
        // 如果连续发生10次404索引问题 则重置video-preview组件
        this.start()
      }
    },
    // **********************************以下为对外提供APi**********************************
    // 获取核心播放能力对象
    getCore() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('getCore')) {
        return this.activeComponent.getCore()
      }
    },
    // 初始化
    init() {
      if(this.initState) return;
      this.initState = true
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent?.hasOwnProperty('init')) {
        this.activeComponent.init()
      }
    },
    // 播放
    play() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('play')) {
        this.activeComponent.play()
      }
    },
    playBtnClick() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('playBtnClick')) {
        this.activeComponent.playBtnClick()
      }
    },
    // 截图 返回base64数据
    screenShot() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('screenShot')) {
        return this.activeComponent.screenShot()
      }
    },
    // 回放功能
    previewBack(startTime, endTime, videoBackCode, location) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('previewBack')) {
        this.activeComponent.previewBack(startTime, endTime, videoBackCode, location)
      }
    },
    // 设置当前布局
    setLayout() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('setLayout')) {
        this.activeComponent.setLayout()
      }
    },
    // 改变播放器位置
    resizePlayer() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('resizePlayer')) {
        this.activeComponent.resizePlayer()
      }
    },
    // 隐藏视频
    hidePlayer() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('hidePlayer')) {
        this.activeComponent.hidePlayer()
      }
    },
    // 显示视频
    showPlayer() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('showPlayer')) {
        this.activeComponent.showPlayer()
      }
    },
    // 全屏API
    fullscreen(isFullscreen) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('fullscreen')) {
        let convertValue = isFullscreen
        convertValue = typeof isFullscreen === 'boolean' ? (isFullscreen ? Action.fullscreen : Action.exitFullscreen) : convertValue
        this.activeComponent.fullscreen(convertValue)
      }
    },
    // VLC全屏API
    openFullscreen() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('openFullscreen')) {
        this.activeComponent.openFullscreen();
      }
    },
    // 创建websocket开始播放
    restartWebSocket(url, data) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('restartWebSocket')) {
        this.activeComponent.restartWebSocket(url, data)
      }
    },
    // 开启jessi对讲
    cancelMute(data) {
      this.activeComponent = this.getActiveComponent()
        this.activeComponent.cancelMute(data)
    },
    // 开启语音对讲
    startVoice(data) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('startVoice')) {
        this.activeComponent.startVoice(data)
      }
    },
    // 关闭语音对讲
    stopVoice() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('stopVoice')) {
        this.activeComponent.stopVoice()
      }
    },
    // 开启声音
    openSound(data) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('openSound')) {
        this.activeComponent.openSound(data)
      }
    },
    // 关闭声音
    closeSound() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('closeSound')) {
        this.activeComponent.closeSound()
      }
    },
    // 静音方法
    changeMute(val) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('changeMute')) {
        this.activeComponent.changeMute(val)
      }
    },
    /**
     * 天池项目特供API 录像回放
     */
    tianchiPreviewBack(startTime, endTime) {
      return new Promise((resolve, reject) => {
        if (!this.code) {
          reject()
          return
        }
        let url = this.proxyHost + URLS.listRecords

        const date = VDate.formatTimeStamp(startTime, 'YYYY-MM-DD')
        const params = {
          code: this.code,
          date: date,
          recordForm: 'device'
        }
        axios
          .get(url, { params })
          .then((res) => {
            if (res.data.result && res.data.result.length > 0) {
              let timeRanges = []
              res.data.result.map((item) => {
                let reg = new RegExp(/[0-9]{4}-[0-9]{2}-[0-9]{2}\/[0-9]{2}-[0-9]{2}-[0-9]{2}/gm)
                const result = item.match(reg)[0]
                if (result) {
                  let splitTime = result.split('/')
                  let hms = splitTime[1].replaceAll('-', ':')
                  let time = `${splitTime[0]} ${hms}`
                  let startTimeStamp = new Date(time).valueOf()
                  let endTimeStamp = new Date(time).valueOf() + 600 * 1000 // 增加10分钟
                  timeRanges.push({ time: [startTimeStamp, endTimeStamp], url: item })
                }
              })

              for (let index = 0; index < timeRanges.length; index++) {
                const item = timeRanges[index]
                // 如果在此区间范围内
                if (startTime < item.time[1] && startTime > item.time[0]) {
                  this.videoSrc = item.url
                  resolve(item.url)
                  break
                }
              }
            }
          })
          .catch((e) => {
            reject(e)
          })
      })
    },

    /**
     * 播放列表功能
     * @param playlist 列表
     * @param index 索引
     * @param startTime 秒级播放起始时间
     */
    playMultVideo(playlist, index, startTime) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('playMultVideo')) {
        return this.activeComponent.playMultVideo(playlist, index, startTime)
      }
    },
    // dispose卸载
    dispose() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('dispose')) {
        return this.activeComponent.dispose()
      }
    },
    // ddhIcc注销
    destroy() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('destroy')) {
        return this.activeComponent.destroy()
      }
    },
    // 获取激活的Component
    getActiveComponent() {
      if (this.videoMode == 0 || this.videoMode == 11) {
        // return this.$refs.h5VideoJS
        return this.$refs.jeVideo
      } else if (this.videoMode == 1) {
        return this.$refs.iframe
      } else if (this.videoMode == 2) {
        return this.$refs.vlc
      } else if (this.videoMode == 3) {
        return this.$refs.hkVideo
      } else if (this.videoMode == 7) {
        return this.$refs.mjVideo
      } 
      // else if (this.videoMode == 11) {
      //   return this.$refs.jeVideo
      // } 
      else if (this.videoMode == 14) {
        return this.$refs.whVideo
      } else if (this.videoMode == 15) {
        return this.$refs.uniview
      }else if (this.videoMode == 16) {
        return this.$refs.DHicc
      }
    },
    // dhicc
      createSuccess(versionInfo){
        console.warn('createSuccess video-preview')
        this.$emit('createSuccess', versionInfo)
        if(this.videoMode == 16){
            // this.$parent.DHiccPlay??this.$parent.DHiccPlay()
            this.DHiccPlay()
        }
      },
      createError(versionInfo){
          console.warn('createError video-preview',versionInfo)
      },
      DHiccPlay(val,num) {
        console.error('click',this.videoSrc,this.DHvideoType);
        if(this.DHvideoType === 'video1'){
            this.realByUrl(
              {
                channelId: '', //''
                path: this.videoSrc,
                redirect: false //false
              },
              0
            )
        }else if(this.DHvideoType === 'video2'){
            // this.$refs.dhplayer.playbackByUrl(
            this.playbackByUrl(
                    {
                        channelId: '',
                        path: this.videoSrc,
                        records: [],
                        redirect: false,
                        startTime: this.DHstartTime, 
                        endTime: this.DHendTime
                    },
                    0
              )
        }
      },
      changePosition(){
        this.activeComponent = this.getActiveComponent()
        if (this.activeComponent && this.activeComponent.hasOwnProperty('changePosition')) {
          return this.activeComponent.changePosition()
        }
      },
      destroySuccess(versionInfo){
        // console.warn('destroySuccess video-preview',versionInfo)
        this.$emit('destroySuccess', versionInfo)
        //  this.$parent.DHiccClose()
      },
      realError(info, err){
        console.warn('realError realError realError');
          this.$emit('realError', info, err)
      },
      talkError(info, err){
          this.$emit('talkError', info, err)
      },
      clickWindow(snum, info){
          this.$emit('clickWindow', snum, info)
      },
      changeDivision(division){
          this.$emit('changeDivision', division)
      },

      picCap({ base64Url, path }, info){
          this.$emit('picCap', {
              base64Url,
              path
          }, info)
      },
      notifyTalk({ channelId, snum }){
          this.$emit('notifyTalk', { channelId, snum })
      },
      realSuccess(info){
        console.warn('realSuccess',info);
          this.$emit('realSuccess', info)
      },
    // DHicc  预览
    realByUrl(val,num) {
      console.error('realByUrl',val,num);
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('realByUrl')) {
        this.activeComponent.realByUrl(val,num)
      }
    },

    closeCallback(val){
      this.$emit('closeCallback',val)
    },
    playFailedAndPaused(val){
      console.log('playFailedAndPaused code:',this.code);
      if(this.code){
          setTimeout(() => {
            this.start()
          }, 500);
        }else{
          console.error('缺少code');
        }
      this.$emit('playFailedAndPaused',val)
    },
    recordBlob(val){
      if(val){
        this.$emit('recordBlob',val)
      }
    },
    /**
    * 云台功能初始化
    */
    initPanTilt(el) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('initPanTilt')) {
        this.activeComponent.initPanTilt(el)
      }
    },
    // 自定义实时预览顶部按钮配置
    setTabControlBtn(val) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('setTabControlBtn')) {
        this.activeComponent.setTabControlBtn(val)
      }
    },
    // 使用云台
    usePanTilt(val) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('usePanTilt')) {
        this.activeComponent.usePanTilt(val)
      }
    },
    // 通过url进行对讲
    talkByUrl(val, snum = 0) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('talkByUrl')) {
        this.activeComponent.talkByUrl(val, snum)
      }
    },
    // 关闭对讲
    closeTalk() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('closeTalk')) {
        this.activeComponent.closeTalk()
      }
    },
    //录像回放
    playbackByUrl(o, snum = 0) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('playbackByUrl')) {
        this.activeComponent.playbackByUrl(o, snum)
      }
    },
    // 录像继续
    playVideo(val) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('playVideo')) {
        this.activeComponent.playVideo(val)
      }
    },
    // 录像暂停
    pauseVideo(val) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('pauseVideo')) {
        this.activeComponent.pauseVideo(val)
      }
    },
    // 改变当前播放器的窗口数
    // changeDivision(val) {
    //   this.activeComponent = this.getActiveComponent()
    //   if (this.activeComponent && this.activeComponent.hasOwnProperty('changeDivision')) {
    //     this.activeComponent.changeDivision(val)
    //   }
    // },
    // 显隐控制栏
    setShowBar(enable = true) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('setShowBar')) {
        this.activeComponent.setShowBar(enable)
      }
    },
    // 抓图
    snapshot(val) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('snapshot')) {
        this.activeComponent.snapshot(val)
      }
    },
    // 下载录像(通过rtsp下载)
    downloadRecord(o, snum = 0) {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('downloadRecord')) {
        this.activeComponent.downloadRecord(o, snum)
      }
    },
    // jessi 录制事件
    recordSwich() {
      this.activeComponent = this.getActiveComponent()
      if (this.activeComponent && this.activeComponent.hasOwnProperty('recordSwich')) {
        this.activeComponent.recordSwich()
      }
    },
    // 初始检测页面中是否存在百度iframe
    detectAndHandleBaiduIframe() {
      // 检测是否存在第三方iframe，特别是百度iframe
      const hasBaiduIframe = detectThirdPartyIframes();
      this.hasBaiduIframe = hasBaiduIframe;
      
      if (hasBaiduIframe) {
        console.log('检测到第三方iframe，启用CSP保护措施');
        
        // 初始化iframe安全处理
        this.iframeObserver = initIframeSafety();
        
        // 查找并处理所有百度相关的iframe
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach(iframe => {
          try {
            // 检查iframe的src属性，判断是否是百度域名
            const iframeSrc = iframe.getAttribute('src') || '';
            if (iframeSrc.includes('baidu.com') || 
                iframeSrc.includes('chat.baidu') || 
                iframeSrc.includes('mirror-chat.baidu') ||
                iframeSrc.includes('fj-chat.baidu') ||
                iframeSrc.includes('hba-chat.baidu') ||
                iframeSrc.includes('hbe-chat.baidu') ||
                iframeSrc.includes('njjs-chat.baidu') ||
                iframeSrc.includes('nj-chat.baidu') ||
                iframeSrc.includes('hna-chat.baidu') ||
                iframeSrc.includes('hnb-chat.baidu') ||
                iframeSrc.includes('debug.baidu-int.com')) {
              
              // 为百度iframe添加专门的通信处理
              setupBaiduIframeComm(iframe);
              
              // 标记百度iframe
              iframe.classList.add('baidu-iframe');
              
              // 设置百度iframe的sandbox属性，以允许必要的功能
              iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups');
              
              // 如果可能，尝试修改iframe内部的CSP
              try {
                if (iframe.contentWindow && iframe.contentWindow.document) {
                  const meta = document.createElement('meta');
                  meta.setAttribute('http-equiv', 'Content-Security-Policy');
                  meta.setAttribute('content', "frame-ancestors 'self' *;");
                  iframe.contentWindow.document.head.appendChild(meta);
                }
              } catch (e) {
                console.warn('无法访问iframe内容:', e);
              }
            }
          } catch (e) {
            console.warn('处理iframe时出错:', e);
          }
        });
        
        // 添加特殊的处理，如果使用的是大华ICC组件
        if (this.videoMode == 16) {
          // 为大华播放器添加额外的参数
          this.dhIccOptions.parentIframeShieldClass = [
            'baidu-iframe', 
            'chat-iframe', 
            'external-iframe', 
            'embed-iframe',
            'chat-container-iframe'
          ];
          
          // 监听特殊事件，处理与百度iframe的交互
          document.addEventListener('dh-player-pause-request', () => {
            if (this.$refs.DHicc && this.$refs.DHicc.videoPlayer) {
              // 暂停视频播放
              this.$refs.DHicc.closeVideo();
            }
          });
        }
      }
    },
  }
}
</script>
